<main class="container-geral">
  <section class="cabecalho">
    <h1 class="titulo">{{ 'COMPONENTS.VELOCIDADE_IDEAL.title' | transloco }}</h1>
  </section>

  <section class="form-section">
    <p class="paragrafo-informacoes">
      {{ 'COMPONENTS.VELOCIDADE_IDEAL.info' | transloco }}
    </p>

    <div class="formulario">
      <form [formGroup]="formulario" class="group-form" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-md-6 mb-4">
            <label class="form-label">
              {{ 'COMPONENTS.VELOCIDADE_IDEAL.minimo' | transloco }}
            </label>

            @if (loading) {
              <app-loading [linhas]="1" [colunas]="1"></app-loading>
            } @else {
              <input formControlName="fl_minimo" type="number" step="0.1" class="input-form form-control" [class.invalido]="
                  formulario.get('fl_minimo')?.invalid && formulario.get('fl_minimo')?.dirty
                " />
            }
          </div>

          <div class="col-md-6 mb-4">
            <label class="form-label">
              {{ 'COMPONENTS.VELOCIDADE_IDEAL.maximo' | transloco }}
            </label>

            @if (loading) {
              <app-loading [linhas]="1" [colunas]="1"></app-loading>
            } @else {
              <input formControlName="fl_maximo" type="number" step="0.1" class="input-form form-control" [class.invalido]="
                  formulario.get('fl_maximo')?.invalid && formulario.get('fl_maximo')?.dirty
                " />
            }
          </div>

          @if (formulario.errors?.['maximoMenorOuIgualAoMinimo']) {
            <div class="col-md-12 mb-2">
              <small class="mensagem-validacao-form">
                *{{ 'COMPONENTS.VELOCIDADE_IDEAL.erro_maximo_menor_que_minimo' | transloco }}
              </small>
            </div>
          }

          <div class="col-md-4 mb-4">
            <label class="form-label">
              {{ 'COMPONENTS.VELOCIDADE_IDEAL.cor_abaixo' | transloco }}
            </label>

            @if (loading) {
              <app-loading [linhas]="1" [colunas]="1"></app-loading>
            } @else {
              <input formControlName="vc_cor_abaixo_minimo" type="color" class="input-form form-control">
            }
          </div>

          <div class="col-md-4 mb-4">
            <label class="form-label">
              {{ 'COMPONENTS.VELOCIDADE_IDEAL.cor_ideal' | transloco }}
            </label>

            @if (loading) {
              <app-loading [linhas]="1" [colunas]="1"></app-loading>
            } @else {
              <input formControlName="vc_cor_ideal" type="color" class="input-form form-control">
            }
          </div>

          <div class="col-md-4 mb-4">
            <label class="form-label">
              {{ 'COMPONENTS.VELOCIDADE_IDEAL.cor_acima' | transloco }}
            </label>

            @if (loading) {
              <app-loading [linhas]="1" [colunas]="1"></app-loading>
            } @else {
              <input formControlName="vc_cor_acima_maximo" type="color" class="input-form form-control">
            }
          </div>
        </div>

        <div class="buttons-form d-flex">
          <button class="btn-cancelar" type="button" (click)="cancelar()">
            <object class="me-2" data="assets/icone-fechar.svg" type="image/svg+xml"></object>
            {{ 'COMPONENTS.VELOCIDADE_IDEAL.cancelar' | transloco }}
          </button>

          <button type="button" class="btn-confirmar" [disabled]="botaoDesabilitado" [class.btn-confirmar-desabilitado]="botaoDesabilitado" (click)="salvar()">
            @if (loadingBotao) {
              <div class="spinner-border text-white spinner-border-sm" role="status">
                <span class="visually-hidden">{{ 'COMPONENTS.VELOCIDADE_IDEAL.loading' | transloco }}</span>
              </div>
            } @else {
              {{ 'COMPONENTS.VELOCIDADE_IDEAL.salvar' | transloco }}
            }
          </button>
        </div>
      </form>
    </div>
  </section>
</main>
